import DefaultCRUD from '../utils'

const resource = `/report-builder/wrapper`;

const { get } = DefaultCRUD(resource)

export default {
  get,
  generate_download(id, ctx) {
    return Api.post(`${resource}/${id}/generate/download_file/`, ctx, {
      responseType: 'blob'
    })
  }
}
